/**
 * Staff of the firm that owns the product are not customers. They get free
 * unlimited access and are placed in the firm automatically at signup, so the
 * client must never show them the plan or payment step.
 *
 * The backend decides entitlement (settings.INTERNAL_EMAIL_DOMAINS); this list
 * only controls what the signup flow displays. Keep the two in step if the
 * backend list ever changes.
 */
const INTERNAL_EMAIL_DOMAINS = ['zindalaw.com'];

export const isInternalEmail = (email?: string | null): boolean => {
  if (!email || !email.includes('@')) return false;
  const domain = email.trim().split('@').pop()?.toLowerCase();
  return !!domain && INTERNAL_EMAIL_DOMAINS.includes(domain);
};

export default isInternalEmail;
